import NotFound from "./NotFound";

 
export const errorRoutes = [
  {
    path: "/error/not-found",
    element: <NotFound />,
  },
];
